import React, { useState } from 'react';
import { AppProvider, useApp } from './hooks/AppContext';
import Login from './components/Login';
import Header from './components/Header';
import ManagerView from './components/ManagerView';
import Dashboard from './components/Dashboard';
import DataManage from './components/DataManage';
import Reports from './components/Reports';
import CutoffPage from './components/CutoffPage';
import UserManage from './components/UserManage';
import WipeModal from './components/WipeModal';
import BackupPage from './components/BackupPage';
import './styles/app.css';

function AppContent() {
  const { user, isAdmin, isHO, isManager } = useApp();
  const [page, setPage] = useState('home');
  const [tab, setTab] = useState('dashboard');
  const [showWipe, setShowWipe] = useState(false);

  if (!user) return <Login />;

  // Manager always sees their confirmation view
  if (isManager) return (
    <>
      <Header page="home" setPage={() => {}} tab="manager" setTab={() => {}} />
      <ManagerView />
    </>
  );

  // Admin and HO routing
  let content;
  if (page === 'report') content = <Reports />;
  else if (page === 'cutoff' && isAdmin) content = <CutoffPage />;
  else if (page === 'users' && isAdmin) content = <UserManage />;
  else if (page === 'backup' && (isAdmin || isHO)) content = <BackupPage />;
  else if (tab === 'admin' && isAdmin) content = <DataManage />;
  else content = <Dashboard />;

  return (
    <>
      <Header page={page} setPage={setPage} tab={tab} setTab={setTab} />
      {content}

      {/* Wipe button (admin only, bottom-right) */}
      {isAdmin && (
        <button className="wipe-fab" onClick={() => setShowWipe(true)} title="Data Wipe">🗑</button>
      )}
      {showWipe && <WipeModal onClose={() => setShowWipe(false)} onComplete={() => window.location.reload()} />}
    </>
  );
}

export default function App() {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
}
